import React from 'react';

const Search = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2.8871 1.095C4.31979 0.13768 6.07409 -0.211292 7.76408 0.12485C8.60088 0.29129 9.3967 0.62092 10.1061 1.09492C10.8155 1.56892 11.4246 2.17801 11.8986 2.8874C12.3726 3.5968 12.7023 4.39261 12.8687 5.22941C13.0352 6.0662 13.0352 6.92759 12.8688 7.76439C12.7023 8.60118 12.3727 9.39701 11.8987 10.1064C11.4247 10.8158 10.8156 11.4249 10.1062 11.8989C8.67353 12.8562 6.91923 13.2052 5.22924 12.8691C3.53925 12.5329 2.05201 11.5392 1.09469 10.1065C0.137375 8.67383 -0.211597 6.91953 0.124545 5.22954C0.460686 3.53955 1.45441 2.05231 2.8871 1.095ZM4.32485 9.74737C4.75157 10.0382 5.2317 10.2417 5.73749 10.3459C6.24328 10.4502 6.76471 10.4532 7.27167 10.3547C7.77863 10.2563 8.26107 10.0584 8.69112 9.77253C9.12117 9.48661 9.49031 9.11831 9.77721 8.68892C10.0641 8.25953 10.2631 7.77754 10.3627 7.27081C10.4623 6.76408 10.4604 6.24264 10.3574 5.73661C10.2543 5.23058 10.0519 4.74999 9.76206 4.3226C9.47218 3.89521 9.10049 3.52949 8.66847 3.24656C7.80632 2.68194 6.7561 2.4806 5.74626 2.68633C4.73643 2.89205 3.84867 3.48821 3.27612 4.34511C2.70357 5.20201 2.49254 6.25033 2.68894 7.26202C2.88533 8.27371 3.47327 9.16693 4.32485 9.74737ZM10.842 13.0304C11.7089 12.4529 12.4526 11.7092 13.0301 10.8423L17.9998 15.812L15.8117 18.0001L10.842 13.0304Z",
      fill: "currentColor"
    }
  )
);
Search.displayName = "Icons.Search";

export { Search };
//# sourceMappingURL=Search.js.map
